/**
 * base_suggestions_silver.js
 * Swiper initialiser for the suggestions carousel widget.
 * Wrapped in an IIFE so top-level consts don't clash when the script is
 * injected more than once on a page (e.g. two suggestions widgets).
 */
(function () {
    const SWIPER_CSS = 'https://media.seekunique.co/websites-cdn-assets/swiper%4011-swiper-bundle.min.css';
    const SWIPER_JS  = 'https://media.seekunique.co/websites-cdn-assets/swiper%4011-swiper-bundle.min.js';

    function loadSuggestionsCSS() {
        if (document.querySelector('link[href*="base_suggestions_silver.min.css"]')) return;
        const cdnBase = (document.querySelector('link[href*="standalone/css/"]')?.href || '')
            .replace(/\/css\/.*$/, '');
        if (!cdnBase) return;
        const href = cdnBase + '/css/suggestions/base_suggestions_silver.min.css';
        const link = Object.assign(document.createElement('link'), { rel: 'stylesheet', href, media: 'print' });
        link.addEventListener('load', () => { link.media = 'all'; });
        document.head.appendChild(link);
    }

    function loadSwiper() {
        return new Promise(resolve => {
            if (window.Swiper) return resolve();
            if (!document.querySelector(`link[href="${SWIPER_CSS}"]`)) {
                const link = Object.assign(document.createElement('link'), {
                    rel: 'stylesheet', href: SWIPER_CSS, media: 'print',
                });
                link.addEventListener('load', () => { link.media = 'all'; });
                document.head.appendChild(link);
            }
            // Script tag may already exist (added by a concurrent carousel init) but
            // not yet executed — attach to its load event instead of resolving early.
            const existing = document.querySelector(`script[src="${SWIPER_JS}"]`);
            if (existing) {
                existing.addEventListener('load', resolve);
                return;
            }
            const script = Object.assign(document.createElement('script'), { src: SWIPER_JS });
            script.addEventListener('load', resolve);
            document.head.appendChild(script);
        });
    }

    function initSuggestionsCarousel(el) {
        if (el._swiperInit) return;
        el._swiperInit = true;
        const cfg = JSON.parse(el.dataset.swiperConfig || '{}');
        const uid = el.dataset.swiperId || '';

        const opts = {
            slidesPerView: cfg.slidesPerView || 4,
            spaceBetween: cfg.spaceBetween || 24,
            loop: !!cfg.loop,
            navigation: {
                nextEl: `.swiper-button-next-custom-${uid}`,
                prevEl: `.swiper-button-prev-custom-${uid}`,
            },
            mousewheel: { forceToAxis: true, sensitivity: 1, releaseOnEdges: true },
            freeMode: { enabled: true, sticky: false, momentum: true, momentumRatio: 1, momentumVelocityRatio: 1 },
            grabCursor: true,
            touchEventsTarget: 'container',
            simulateTouch: true,
            allowTouchMove: true,
            breakpoints: {
                320:  { slidesPerView: 1, spaceBetween: 16 },
                640:  { slidesPerView: 2, spaceBetween: 20 },
                768:  { slidesPerView: 3, spaceBetween: 24 },
                1024: { slidesPerView: cfg.slidesPerView || 4, spaceBetween: cfg.spaceBetween || 24 },
            },
        };

        if (cfg.autoplay) {
            opts.autoplay = {
                delay: cfg.autoplayDelay || 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            };
        }

        return new Swiper(el, opts);
    }

    function initAll() {
        const els = document.querySelectorAll('.js-suggestions-carousel');
        if (!els.length) return;
        loadSuggestionsCSS();
        loadSwiper().then(() => els.forEach(initSuggestionsCarousel));
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }

    document.body.addEventListener('htmx:afterSettle', initAll);
}());
